import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { commonVar } from "../../../../providers/common-var/common";

/**
 * Generated class for the NumberInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "number-input",
  templateUrl: "number-input.html",
})
export class NumberInputComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  placeholder: string = "";
  max: number;
  min: number;
  maxLength: number;
  minLength: number;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  numberOnly: boolean = false;
  symbol: any;
  maxLengthValidator;
  minLengthValidator;

  innerGroup: FormGroup;
  isCreatinine = false;

  constructor(public formBuilder: FormBuilder) {
    this.maxLengthValidator = (control: FormControl) => {
      let value = control.value;
      if (value !== null && value !== undefined) {
        let length = control.value.toString().length;
        if (length > this.maxLength) {
          return { maxlength: true };
        }
      }
    };

    this.minLengthValidator = (control: FormControl) => {
      let value = control.value;
      if (value !== null && value !== undefined) {
        let length = control.value.toString().length;
        if (length < this.minLength) {
          return { minlength: true };
        }
      }
    };
  }

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.isCreatinine = commonVar.containsWord(
      commonVar.CREATININE_VALUE,
      this.id
    );
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    if (this.config.placeholder) {
      this.placeholder = this.config.placeholder;
    }

    this.group.addControl(this.id, this.formBuilder.control(""));

    this.innerGroup = this.formBuilder.group({});
    this.innerGroup.addControl("number", this.formBuilder.control(""));
    this.disabled = this.group.controls[this.id].disabled;
    this.numberOnly = this.config.numberOnly;
    this.symbol = this.config.symbol;
    var validators = [];
    if (this.config.rules) {
      if (this.config.rules.required) {
        this.required = this.config.rules.required;
        validators.push(Validators.required);
      }

      if (this.config.rules.min !== undefined) {
        this.min = this.config.rules.min;
        validators.push(Validators.min(this.min));
      }

      if (this.config.rules.max !== undefined) {
        this.max = this.config.rules.max;
        validators.push(Validators.max(this.max));
      }

      if (this.config.rules.minLength !== undefined) {
        this.minLength = this.config.rules.minLength;
        validators.push(this.minLengthValidator);
      }

      if (this.config.rules.maxLength !== undefined) {
        this.maxLength = this.config.rules.maxLength;
        validators.push(this.maxLengthValidator);
      }
    }

    var composedValidators: ValidatorFn = Validators.compose(validators);

    let selfControl = this.group.controls[this.id];

    this.innerGroup.controls["number"].setValidators(composedValidators);

    selfControl.valueChanges.subscribe((data) => {
      if (this.disabled !== selfControl.disabled) {
        this.disabled = selfControl.disabled;
        if (selfControl.disabled) {
          this.innerGroup.disable();
        } else {
          this.innerGroup.enable();
        }
      }
      if (
        data !== this.innerGroup.controls["number"].value &&
        (this.innerGroup.controls["number"].value === null ||
          this.innerGroup.controls["number"].value === "")
      ) {
        this.innerGroup.controls["number"].setValue(data);
      } else if (
        data === null &&
        data !== this.innerGroup.controls["number"].value
      ) {
        this.innerGroup.controls["number"].setValue(null);
      }
    });

    const updateVal = (val) => {
      if (val === "" || val === null) {
        selfControl.setValue(null);
      } else if (typeof val === "number") {
        selfControl.setValue(val);
      } else {
        selfControl.setValue(+val);
      }
      selfControl.setErrors(this.innerGroup.controls["number"].errors);
    };

    this.innerGroup.controls["number"].valueChanges.subscribe((data) => {
      updateVal(data);
    });

    this.innerGroup.statusChanges.subscribe((data) => {
      selfControl.setErrors(this.innerGroup.controls["number"].errors);
    });

    updateVal(selfControl.value);
  }

  checkforNumbers(event) {
    let valid = this.validateNumber(event);
    if (valid) {
      if (this.numberOnly) {
        if (event.which === 46) {
          event.preventDefault();
        }
      }
    }
  }

  validateNumber(event) {
    var key = window.event ? event.keyCode : event.which;
    if (key == 46 || key == 8 || key == 0 || key == 110) {
      return true;
    } else if (key < 48 || key > 57) {
      event.preventDefault();
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/number-input/number-input.ts